/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  local: false,
  production: true,
  env: '',
  region: 'us-west-2',

  identityPoolId: 'us-west-2:4b0b64d2-cd05-47cd-903b-1e5b05ed94d9',
  userPoolId: 'us-west-2_uANT15oLm',
  clientId: '2psfqkggirokjr274mn53vd3a8',

  // rekognitionBucket: 'rekognition-pics',
  // albumName: 'usercontent',
  // bucketRegion: 'us-east-1',

  // ddbTableName: 'LoginTrail',

  cognito_idp_endpoint: '',
  cognito_identity_endpoint: '',
  sts_endpoint: '',
  dynamodb_endpoint: '',
  s3_endpoint: '',

  // urls
  staff_activity_get: 'https://pkvkwdc15d.execute-api.us-west-2.amazonaws.com/prod/staff',
  public_access_key: '8d6f558a-3d2a-48a9-8816-71a822e9cf61',
  esb_managerbyemail_url: 'https://apps.nearshoretc.com/getManagerInfo/GetManagerByEmail',
  esb_staff_url: 'https://apps.nearshoretc.com/getManagerInfo/GetStaff',
  esb_check: 1
};
